import CreditCardSvg from '@assets/images/svg/credit-card.svg';
import React from 'react';
import { View } from 'react-native';

export interface CreditCardIconProps {
    size?: number;
    color?: string;
}

export function CreditCardIcon({ size = 78, color = 'white' }: CreditCardIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CreditCardSvg width={size} height={size} color={color} />
        </View>
    );
}
